import React, { useEffect, useState, useRef, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import AddressModal from "../../Component/Modals/address_modal";
import DataContext from "../../Component/context";
import { ApiService } from "../../Component/services/apiServices";
import AccountHeader from "../../Component/Header/account_header";
import Footer from "../../Component/Footer";

function Address() {
  const contextValues = useContext(DataContext)
  const navigate = useNavigate();
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const didMountRef = useRef(true);
  const fetchaddress = useCallback(() => {
    setSpinnerLoading(true);
    ApiService.fetchData("get-address").then((res) => {
      if (res.status === "success") {
        contextValues.setAddressList(res.resUserAddress);
        if (res.resUserAddress.length > 0) {
          contextValues.setSelectedAddress(res.rowAddressDefault);
          localStorage.setItem('SELECTED_ADDRESS', JSON.stringify(res.rowAddressDefault));
        } else {
          contextValues.setSelectedAddress({});
          localStorage.removeItem('SELECTED_ADDRESS');
        }
        setSpinnerLoading(false);
      } else if (res.status === "session_expired") {
        localStorage.removeItem("USER_SESSION");
        setTimeout(() => {
          setSpinnerLoading(false);
          navigate("/");
        }, 1000);
      }
    })
  }, []);

  useEffect(() => {
    if (didMountRef.current) {
      fetchaddress();
    }
    didMountRef.current = false
  }, [fetchaddress]);



  const addressModal = () => {
    contextValues.setUserAddressDetails({
      ua_id: 0,
      ua_name: "",
      ua_email: "",
      ua_mobile: "",
      ua_state_name: "",
      ua_city_name: "",
      ua_address_type: "Home",
      ua_address_type_other: "",
      ua_house_no: "",
      ua_pincode: "",
      ua_suburb: "",
      ua_suburb_id: 0,
      ua_user_id: "",
      ua_default_address: "",
      ua_floor: "",
      ua_country_id: 13,
      ua_country_name: "Australia",
      ua_latitude: "",
      ua_longitude: "",
      ua_complete_address: "",
      ua_how_to_reach: "",
    });
    contextValues.setToggleAddressModal(!contextValues.toggleAddressModal)
  }
  const deleteaddress = (value) => {
    if (window.confirm("Are you sure about delete the address ?")) {
      const dataString = {
        addr_id: value,
      };
      ApiService.postData("remove-address", dataString).then((res) => {
        if (res.status === "success") {
          fetchaddress();
        } else if (res.status === 'session_expired') {
          localStorage.removeItem('USER_TOKEN')
          window.location.href = '/'
        } else {

        }
      });
    }
  };

  const editAddress = (value) => {
    contextValues.setUserAddressDetails({
      ua_id: value.ua_id,
      ua_name: value.ua_name,
      ua_email: value.ua_email,
      ua_mobile: value.ua_mobile,
      ua_state_name: value.ua_state_name,
      ua_city_name: value.ua_city_name,
      ua_address_type: value.ua_address_type,
      ua_address_type_other: value.ua_address_type_other,
      ua_house_no: value.ua_house_no,
      ua_pincode: value.ua_pincode,
      ua_suburb: value.ua_suburb,
      ua_suburb_id: value.ua_suburb_id,
      ua_user_id: value.ua_user_id,
      ua_default_address: value.ua_default_address,
      ua_floor: value.ua_floor,
      ua_country_id: value.ua_country_id,
      ua_country_name: value.ua_country_name,
      ua_latitude: value.ua_latitude,
      ua_longitude: value.ua_longitude,
      ua_complete_address: value.ua_complete_address,
      ua_how_to_reach: value.ua_how_to_reach,
    })
    contextValues.setToggleAddressModal(!contextValues.toggleAddressModal)
  }


  return (
    <>
      <AccountHeader heading={'My Address'}></AccountHeader>
      <div id="appCapsule">
        <div className="mwapper">
          {spinnerLoading ? (
            <div >
              {[...Array(4)].map((_, index) => (
                <Skeleton width={"100%"} height={"150px"} key={index}></Skeleton>
              ))}
            </div>
          ) : (
            <>
              {contextValues.addressList.length > 0 ? (
                <>
                  <div className="p-15" style={{ borderBottom: '5px solid #f4f5f8' }}>
                    <button
                      className="btn btn-outline-primary btn-md btn-full"
                      onClick={(e) => {
                        addressModal();
                      }}
                    >
                      <i className="ri-add-circle-line"></i> Add New Address
                    </button>
                  </div>
                  {contextValues.addressList.map((value, index) => (
                    <div className="addressbox" key={index}>
                      <h6 className="mb-2"> {value.ua_address_type}</h6>
                      {value.ua_address_type === 'Other' ? <p>value?.ua_address_type_other </p> : ''}
                      <p className="tx-16 mb-0">
                        {[value.ua_house_no, value.ua_floor]
                          .filter(Boolean)
                          .join(", ")}
                      </p>
                      <p className="tx-16">
                        {[value.ua_complete_address, value.ua_area, value.ua_city_name, value.ua_state_name, value.ua_pincode, value.ua_how_to_reach]
                          .filter(Boolean)
                          .join(", ")}
                      </p>
                      <div className="d-flex align-items-center gap10 mt-10">
                        <a href="javascript:void(0)" onClick={() => { editAddress(value) }}><i className="ri-pencil-line"></i> Edit</a>
                        <a href="javascript:void(0)" onClick={() => { deleteaddress(value?.ua_id) }}><i className="ri-delete-bin-6-line"></i> Delete</a>
                      </div>
                    </div>
                  ))}

                </>

              ) : (
                <div className="noimg text-center">
                  <img
                    src="/img/noaddress.png"
                    style={{ width: "250px" }}
                    className="mb-3"
                    alt="Daadi's kitchen"
                  />
                  <h5>Save Your Address Now!</h5>
                  <p>
                    Add your home and office addresses and enjoy faster checkout
                  </p>
                  <button
                    className="btn btn-outline-primary  btn-md mt-2"
                    onClick={(e) => {
                      addressModal();
                    }}
                  >
                    Add New Address <i className="ri-add-circle-line"></i>
                  </button>
                </div>
              )}

            </>
          )}
        </div>

      </div>

      <Footer />
      {contextValues.toggleAddressModal && (<AddressModal />)}
    </>
  );
}
export default Address;
